module.exports = __webpack_public_path__ + "static/media/rooster-sound.27804d1f.mp3";